import { useEffect } from 'react';
import { useLocation } from 'react-router';

const BASE_TITLE = 'OptiSigns';

/**
 * Route-to-title mapping matching scio1 page titles.
 * Longest keys first so /app/s/personal-profile matches before shorter prefixes.
 */
const PAGE_TITLES: [string, string][] = [
  // Settings pages (/app/s/*)
  ['s/personal-profile', 'Personal Profile'],
  ['s/company-profile', 'Company Settings'],
  ['s/account-members', 'Account Members'],
  ['s/subscription-plan', 'Subscription Plan'],
  ['s/payment-history', 'Payment History'],
  ['s/payment', 'Payment'],
  ['s/order-device', 'Order Devices'],
  ['s/ordered-device', 'Order History'],
  ['s/credentials', 'Credentials'],
  ['s/apikeys', 'API Keys'],
  ['s/preference-settings', 'Preference'],
  ['s/operational-schedule', 'Operational Schedule'],
  ['s/approval-list', 'Approval List'],
  ['s/sub-account-billing', 'Sub-Account Billing'],
  ['s/coupons', 'Coupons'],
  ['s/proof-of-play-settings', 'Proof of Play Settings'],
  ['s/branding-settings', 'Branding'],
  ['s/monitoring-alert-rules', 'Monitoring Alert Rules'],
  ['s/saml-settings', 'SAML'],
  ['s/integrations', 'Integrations'],
  ['s/external-coms', 'External Communications (RS232)'],
  ['s/share-links-admin', 'Share Links Admin'],
  ['s/datasources-admin', 'DataSources'],
  ['s/feeds-admin', 'Feeds Admin'],
  ['s/social', 'Social'],
  ['s/functional-locations', 'Functional Locations'],

  // Main content pages
  ['screenManagement', 'Screens Management'],
  ['assetManagement', 'Assets Management'],
  ['playlistManagement', 'Playlists Management'],
  ['scheduleManagement', 'Schedules Management'],
  ['templateManagement', 'Templates Management'],
  ['designManagement', 'Designer'],
  ['engageManagement', 'Engage Management'],
  ['crm-management', 'Engage Hub'],
  ['feeds', 'Feeds'],

  // Analytics
  ['playbackReport', 'Proof of Play'],
  ['ai-analytics', 'AI Analytics'],
  ['security-audit-logging', 'Security Audit Logging'],

  // MDM
  ['mdm/templates', 'Provisioning Templates'],
  ['mdm/wifi-profiles', 'Wi-Fi & 802.1X'],
];

/**
 * Sets document.title based on current route, matching scio1 convention:
 * "OptiSigns – Screens Management", etc.
 * Falls back to "OptiSigns" for unmapped routes.
 */
export function usePageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const appPath = pathname.replace('/app/', '');
    const match = PAGE_TITLES.find(([key]) => appPath.startsWith(key));
    document.title = match ? `${BASE_TITLE} – ${match[1]}` : BASE_TITLE;
  }, [pathname]);
}
